import React from "react";
import { Button, Modal } from "antd";
import conf from "../config";


const helpEmail = localStorage.getItem("helpEmail") || conf.helpEmail;
const helpPhone = localStorage.getItem("helpPhone") || conf.helpPhone;
const HelpModal = ({ show, closeModal }) => {
  const shareToWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send/?phone=${helpPhone}&text&type=phone_number&app_absent=0`
    );
  };

  const sendEmail = () => {
    window.open("https://www.google.com/intl/en/gmail/about/");
  };

  return (
    <>
      <Modal
        title="Support"
        open={show}
        onCancel={() => closeModal()}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {conf.project !== 'proawtltrack' &&
            <Button
              onClick={() => sendEmail()}
              icon={
                <i
                  class="bi bi-envelope"
                  style={{ fontSize: "18px", color: "red" }}
                ></i>
              }
            >
              {/* {conf.project === "starlingeye" ? 'support@starlingtechs.com' :
                conf.project === 'proawtltrack' ? 'vijeta@pointmatrix.ae' : 'vijeta@pointmatrix.ae'} */}
              {helpEmail}
            </Button>

          }
          {conf.project === 'proawtltrack' &&
            <Button
              onClick={() => shareToWhatsApp()}
              icon={
                <i
                  class="bi bi-whatsapp"
                  style={{ fontSize: "18px", color: "green" }}
                ></i>
              }
            >
              +966115003419
            </Button>}

          <Button
            icon={
              <i
                class="bi bi-telephone"
                style={{ fontSize: "18px", color: "teal" }}
              ></i>
            }
          >
            {/* {conf.project === "starlingeye" ? "+97142734585" :
              conf.project === 'proawtltrack' ? '+966115003419' : '+971503606930'} */}
            {helpPhone}
          </Button>
        </div>
        <br />
        <p>
          If you need further assistance, please contact the provided support
          numbers.
        </p>
      </Modal>
    </>
  );
};

export default HelpModal;
